import { render } from "./HouseholdSelection.vue?vue&type=template&id=64d94f99&scoped=true"
import script from "./HouseholdSelection.vue?vue&type=script&lang=js"
export * from "./HouseholdSelection.vue?vue&type=script&lang=js"

import "./HouseholdSelection.vue?vue&type=style&index=0&id=64d94f99&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d94f99"]])

export default __exports__